module.exports = __webpack_public_path__ + "static/media/flag-usa.06e674e8.svg";